export default __webpack_public_path__ + "static/media/P-035.754de67d.png";